var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReceivablesFinancing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.7298 51H10.4398C8.72984 51 7.33984 49.61 7.33984 47.9V10.93C7.33984 9.21996 8.72984 7.82996 10.4398 7.82996H34.7298C36.4398 7.82996 37.8298 9.21996 37.8298 10.93V47.9C37.8298 49.61 36.4398 51 34.7298 51Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7298 51H10.4398C8.72984 51 7.33984 49.61 7.33984 47.9V10.93C7.33984 9.21996 8.72984 7.82996 10.4398 7.82996H34.7298C36.4398 7.82996 37.8298 9.21996 37.8298 10.93V47.9C37.8298 49.61 36.4398 51 34.7298 51Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1398 47.58H13.8598C12.1498 47.58 10.7598 46.19 10.7598 44.48V7.52004C10.7598 5.81004 12.1498 4.42004 13.8598 4.42004H38.1498C39.8598 4.42004 41.2498 5.81004 41.2498 7.52004V44.49C41.2398 46.2 39.8598 47.58 38.1398 47.58Z",
    fill: "#FFCF00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1398 47.58H13.8598C12.1498 47.58 10.7598 46.19 10.7598 44.48V7.52004C10.7598 5.81004 12.1498 4.42004 13.8598 4.42004H38.1498C39.8598 4.42004 41.2498 5.81004 41.2498 7.52004V44.49C41.2398 46.2 39.8598 47.58 38.1398 47.58Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5599 44.17H17.2699C15.5599 44.17 14.1699 42.78 14.1699 41.07V4.1C14.1699 2.39 15.5599 1 17.2699 1H41.5599C43.2699 1 44.6599 2.39 44.6599 4.1V41.07C44.6599 42.78 43.2699 44.17 41.5599 44.17Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5599 44.17H17.2699C15.5599 44.17 14.1699 42.78 14.1699 41.07V4.1C14.1699 2.39 15.5599 1 17.2699 1H41.5599C43.2699 1 44.6599 2.39 44.6599 4.1V41.07C44.6599 42.78 43.2699 44.17 41.5599 44.17Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4902 29.1H39.3402",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4902 33.4H39.3402",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4902 37.7H39.3402",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7693 16.92C34.7493 16.69 34.6693 16.37 34.5393 15.97C34.3993 15.57 34.2093 15.23 33.9493 14.95C33.6893 14.67 33.3093 14.37 32.7993 14.06C32.2893 13.75 31.6793 13.5 30.9593 13.31L30.3693 13.16V9.71002C30.6393 9.79002 30.8793 9.94002 31.0893 10.19C31.3993 10.55 31.5593 10.99 31.5693 11.5H34.3093C34.2293 10.24 33.7993 9.27002 33.0193 8.60002C32.3193 8.00002 31.4293 7.62002 30.3693 7.44002V5.90002H29.9693H28.8293H28.4493V7.43002C27.3493 7.57002 26.4193 7.95002 25.6393 8.59002C24.7793 9.30002 24.3493 10.28 24.3493 11.52C24.3493 12.14 24.4493 12.67 24.6593 13.12C24.8693 13.57 25.1693 13.94 25.5793 14.22C25.9893 14.5 26.3793 14.73 26.7793 14.9C27.1693 15.07 27.6493 15.22 28.2193 15.36C28.3093 15.38 28.3893 15.4 28.4593 15.42V19.47C28.0093 19.32 27.6393 19.08 27.3293 18.73C26.9393 18.29 26.7593 17.72 26.7693 17.02H24.0293C24.2993 19.87 25.7793 21.46 28.4593 21.79V23.47H28.8393H29.9793H30.3793V21.79C30.9593 21.72 31.4793 21.6 31.9593 21.42C32.5493 21.19 33.0093 20.93 33.3493 20.63C33.6893 20.33 33.9793 19.99 34.2093 19.63C34.4393 19.26 34.5993 18.93 34.6793 18.63C34.7593 18.33 34.8093 18.05 34.8093 17.81C34.7993 17.45 34.7893 17.16 34.7693 16.92ZM27.4893 12.23C27.2293 12 27.0893 11.67 27.0893 11.25C27.0893 10.74 27.2593 10.34 27.5993 10.06C27.8493 9.86002 28.1293 9.73002 28.4493 9.68002V12.69C28.0293 12.57 27.6993 12.41 27.4893 12.23ZM31.4293 19.01C31.1093 19.25 30.7593 19.42 30.3693 19.51V15.98C30.9393 16.16 31.3593 16.35 31.5993 16.56C31.8993 16.82 32.0493 17.19 32.0493 17.68C32.0593 18.24 31.8493 18.69 31.4293 19.01Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceivablesFinancing);
export default __webpack_public_path__ + "static/media/ReceivablesFinancing.5f8696a2b6c490fd9ef077e72e8e5c99.svg";
export { ForwardRef as ReactComponent };